import { render, staticRenderFns } from "./Teen7.vue?vue&type=template&id=aedcd2be&scoped=true&"
import script from "./Teen7.vue?vue&type=script&lang=js&"
export * from "./Teen7.vue?vue&type=script&lang=js&"
import style0 from "./Teen7.vue?vue&type=style&index=0&id=aedcd2be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedcd2be",
  null
  
)

export default component.exports